var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslator = function SvgTranslator(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 2.417h3.333m0 0h3.334A6.664 6.664 0 0 1 4.083 8.19m0-5.774V.75m0 7.441a6.636 6.636 0 0 1-3.333.892m3.333-.892A6.7 6.7 0 0 1 1.642 5.75m2.441 2.441c.98.568 2.12.892 3.334.892m8.333 6.667v-.053c0-.827-.088-1.647-.258-2.447m-6.409 2.5v-.053c0-.827.088-1.647.259-2.447m0 0a11.728 11.728 0 0 1 2.311-4.88.977.977 0 0 1 1.527 0 11.73 11.73 0 0 1 2.312 4.88m-6.15 0h6.15"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslator);
export default ForwardRef;